module.exports = __webpack_public_path__ + "media/common-loon-2.ed528e1a.mp3";